import { useSearchParams } from "react-router-dom";
import style from "./PaymentStatusPage.module.scss";
import { usePaymentStatusProxyQuery } from "@RTKQuery/admin/proxy/proxy";
import { RiLoader5Fill } from "react-icons/ri";
import { Chip } from "@ui";

export function PaymentStatusPage() {
    const [queryParams] = useSearchParams();

    const {isSuccess, isLoading, isError} = usePaymentStatusProxyQuery({
        id: Number(queryParams.get("id") || -1),
        token: queryParams.get("token") || ""
    });

    return (
        <main className={style.page}>
            <div className={style.container}>
                {isLoading ? <RiLoader5Fill className={"animate-spin text-[20px]"} /> : null}
                {isSuccess ? <Chip text="Успішно оновлено" color="green" size="big"/> : null}
                {isError ? <Chip text="Сталась помилка" color="red" size="big"/> : null}
            </div>
        </main>
    )
}